const applySequentialStopOrder = (stops) =>
  stops.map((stop, index) => ({
    ...stop,
    stop_order: index + 1,
  }));

export const normalizeStoppingPointOrder = (stops) =>
  applySequentialStopOrder(
    [...stops].sort(
      (a, b) =>
        (Number(a.stop_order) || Number.MAX_SAFE_INTEGER) -
        (Number(b.stop_order) || Number.MAX_SAFE_INTEGER),
    ),
  );

export const reorderStoppingPoints = (stops, sourceIndex, destinationIndex) => {
  const orderedStops = normalizeStoppingPointOrder(stops);
  if (destinationIndex == null || sourceIndex === destinationIndex) {
    return orderedStops;
  }

  const safeSourceIndex = Math.max(1, sourceIndex);
  const safeDestinationIndex = Math.max(1, destinationIndex);
  const reorderedStops = [...orderedStops];
  const [movedStop] = reorderedStops.splice(safeSourceIndex, 1);

  if (!movedStop) {
    return orderedStops;
  }

  reorderedStops.splice(safeDestinationIndex, 0, movedStop);
  return applySequentialStopOrder(reorderedStops);
};
